import { render, staticRenderFns } from "./InventorySurplus.vue?vue&type=template&id=31ff8f1f&scoped=true"
import script from "./InventorySurplus.vue?vue&type=script&lang=js"
export * from "./InventorySurplus.vue?vue&type=script&lang=js"
import style0 from "./InventorySurplus.vue?vue&type=style&index=0&id=31ff8f1f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ff8f1f",
  null
  
)

export default component.exports